import * as React from 'react';
import {useState} from 'react';
import {Form} from "@intelingu/core/components/form/Form";
import {WordMasks, WordMasksController} from "../../../partials/WordMasks";
import {WorkspaceStore} from "../../../../stores/WorkspaceStore";
import {container} from "@intelingu/core/IoC/container";
import {Field} from "@intelingu/core/components/form/Field";
import {AudioRecorder} from "../../../partials/AudioRecorder";
import {SubmitButton} from "../../../partials/form/elements/SubmitButton";
import {TinyMCE} from "../../../partials/form/elements/TinyMCE";
import {Checkbox} from "../../../partials/form/elements/Checkbox";
import {getParam} from "../../../../utils/getParam";
import {QuotaCheckField} from "../../../partials/QuotaCheckField";
import {FormGroup} from "../../../partials/form/elements/FormGroup";
import {
    SearchAlreadyCreatedCardsDocument,
    SearchAlreadyCreatedCardsQuery,
    SearchAlreadyCreatedCardsQueryVariables,
    useCreateCardMutation,
    useGetStageForCourseQuery,
    useGetTranslationForVocabularyQuery
} from "../../../../types.d";
import Async from 'react-select/async';
import {Link} from "react-router-dom";
import {Redirect} from "react-router";
import {IsNotEmpty, Validate, ValidateIf} from "class-validator";
import {MceValidator} from "../../../../utils/mceValidator";
import {FormStore} from "@intelingu/core/stores/FormStore";
import {Observer} from "mobx-react";
import {TextInput} from "../../../partials/form/elements/TextInput";
import {CardTypeId} from "../../../../utils/constants";
import {RecentTopic} from "../../../partials/RecentTopic";
import debounce from "debounce-promise";
import {graphql} from "../../../../configs/graphql.client";
import {FormErrorMessage} from "../../../partials/form/FormErrorMessage";

export class Validator {

    @Validate(MceValidator)
    exampleSentence;

    @Validate(MceValidator)
    exampleSentenceTranslation;

    @Validate(MceValidator)
    exampleSentenceTranslation2;

    @Validate(MceValidator)
    exampleSentence2;

    @IsNotEmpty()
    infinitivesOnly;

    @IsNotEmpty()
    infinitivesOnly2;

    @ValidateIf(o => !o.quotaExplanation1Valid)
    @IsNotEmpty()
    quotaExplanation1;

    @ValidateIf(o => !o.quotaExplanation2Valid)
    @IsNotEmpty()
    quotaExplanation2;

    @ValidateIf(o => !o.counterQuotaExplanation1Valid)
    @IsNotEmpty()
    counterQuotaExplanation1;

    @ValidateIf(o => !o.counterQuotaExplanation2Valid)
    @IsNotEmpty()
    counterQuotaExplanation2;

    @IsNotEmpty()
    sentenceAudio;

    @IsNotEmpty()
    sentenceAudio2;

}

export function useAppendToMce(mce) {
    return value => {
        console.log(mce.editor
            .getContent());

        return mce.editor
            .setContent(
                '<p>' +
                mce.editor
                    .getContent()
                    .replace(/<[^>]*>/g, '') + ' ' + value.word +
                '</p>'
            );
    };
}

export const CreateVocabularyForm = props => {
    const [created, setCreated] = useState<boolean>(false);
    const [form, setForm] = useState<FormStore>();

    const [masksController, setMasksController] = useState<WordMasksController>();
    const [masksController2, setMasksController2] = useState<WordMasksController>();
    const [editorRef, setEditorRef] = useState<any>();
    const [editorRef2, setEditorRef2] = useState<any>();

    const appendToMce1 = useAppendToMce(editorRef);
    const appendToMce2 = useAppendToMce(editorRef2);

    const courseId = container.get(WorkspaceStore).courseId;

    const translation = useGetTranslationForVocabularyQuery({
        fetchPolicy: 'network-only',
        variables: { id: getParam<number>('translation_id') }
    });

    const stage = useGetStageForCourseQuery({
        fetchPolicy: 'network-only',
        variables: { courseId }
    });

    const [ createCard, { data: createdCard } ] = useCreateCardMutation({
        fetchPolicy: 'no-cache'
    });

    if (!translation.data || !stage.data) {
        return <h2>Loading...</h2>
    }

    const { wordTranslation } = translation.data;
    const rank = wordTranslation.sourceWord.rank;

    if (created) {
        return <Redirect to={`/creation/next/${courseId}/LP`} />
    }

    return <Form
        validator={Validator}
        defaultData={{
            postTitle: wordTranslation.sourceWord.lemma,
            exampleSentence: wordTranslation.sourceWord.lemma,
            exampleSentence2: wordTranslation.sourceWord.lemma,
            course: courseId,
            stage: stage.data.stageForCourse.id,
            wordTranslation: wordTranslation.id,
            editingRequiredAt: wordTranslation.sourceWord.predefinedComment ? '1' : null,
            editingRequiredComment: wordTranslation.sourceWord.predefinedComment || '',
            cardType: CardTypeId.Vocabulary,
        }}
        onReady={data => setForm(data.store)}
        onSubmit={async (data, done) => {
            const value = JSON.parse(JSON.stringify(data));

            delete value.quotaExplanation1Valid;
            delete value.counterQuotaExplanation1Valid;
            delete value.quotaExplanation2Valid;
            delete value.counterQuotaExplanation2Valid;

            console.log('create card request');
            await createCard({
                variables: {
                    input: value
                }
            });

            done();

            setCreated(true);
        }}
    >
        <div className="ig-form-heading">
            <h1 className="form-primary-title">Vocabulary Card: Design Great Content</h1>
        </div>

        <div className="row px-3 ig-head-info-primary">
            <div className="col-4">
                <label><strong>Vocabulary</strong>:</label>
                <span className="mx-1 source-word-value">{ wordTranslation.sourceWord.lemma }</span>
            </div>
            <div className="col-8">
                <label><strong>Translation</strong>:</label>
                <span className="mx-1">{ wordTranslation.translationWord.lemma }</span>
            </div>
        </div>

        <div className="row px-3">
            <div className="col-4">
                <label><strong>Part Of Speech</strong>:</label>
                <span className="mx-1">{ wordTranslation.sourceWord.posDefinition } ({ wordTranslation.sourceWord.pos })</span>
            </div>
            <div className="col-8">
                <label><strong>Position of Vocabulary</strong>:</label>
                <span className="mx-1">{ rank }</span>
            </div>
        </div>

        <div className="row px-3">
            <div className="col-12">
                <Link to={`/lp/translation/?translation_id=${wordTranslation.id}`} className="btn btn-outline-primary ">Revise translation</Link>
            </div>
        </div>

        <FormGroup
            className={'mt-5'}
            label={'1st MNEMO-ENHANCER: Relevant (ordinary) usage of vocabulary'}
            required={true}
        >
            <WordMasks
                onReady={setMasksController}
                courseId={container.get(WorkspaceStore).courseId}
                onSelect={appendToMce1}
                rank={rank} />

            <Field
                name={'exampleSentence'}
                render={props => (
                    <TinyMCE
                        toolbar={''}
                        editor={setEditorRef}
                        {...props} />
                )} />
        </FormGroup>

        <FormGroup label={'Sentence audio (record hotkey: Ctrl+1)'} required={true}>
            <Field
                name={'sentenceAudio'}
                render={props => <AudioRecorder {...props} />} />
        </FormGroup>

        <FormGroup label={'Infinitives Only'} required={true}>
            <Field name={'infinitivesOnly'} render={props => (
                <QuotaCheckField
                    includedWords={[wordTranslation.sourceWord.lemma]}
                    sourceLanguage={wordTranslation.sourceLanguage.id}
                    translationLanguage={wordTranslation.translationLanguage.id}
                    explanationQuotaFieldName={'quotaExplanation1'}
                    explanationCounterFieldName={'counterQuotaExplanation1'}
                    wordMasksController={masksController}
                    getInfinitives={() => editorRef.editor.getContent({format: 'text'})}
                    {...props} />
            )} />
        </FormGroup>

        <FormGroup label={'TRANSLATION OF 1st MNEMO-ENHANCER'} required={true}>
            <Field
                name={'exampleSentenceTranslation'}
                render={props => <TinyMCE toolbar={''} {...props} />} />
        </FormGroup>

        <div className={'separator'} />

        <FormGroup label={'2nd MNEMO-ENHANCER: Application of recent Grammar Topic'} required={true}>
            <RecentTopic
                translationLanguage={wordTranslation.translationLanguage.id}
                sourceLanguage={wordTranslation.sourceLanguage.id}
                cardId={wordTranslation.id}
                rank={rank} />

            <WordMasks
                onReady={setMasksController2}
                courseId={container.get(WorkspaceStore).courseId}
                onSelect={appendToMce2}
                rank={rank} />

            <Field
                name={'exampleSentence2'}
                render={props => (
                    <TinyMCE
                        toolbar={''}
                        editor={setEditorRef2}
                        {...props} />
                )} />
        </FormGroup>

        <FormGroup label={'Sentence audio (record hotkey: Ctrl+1)'} required={true}>
            <Field
                name={'sentenceAudio2'}
                render={props => <AudioRecorder {...props} />} />
        </FormGroup>

        <FormGroup label={'Infinitives Only'} required={true}>
            <Field name={'infinitivesOnly2'} render={props => (
                <QuotaCheckField
                    includedWords={[wordTranslation.sourceWord.lemma]}
                    sourceLanguage={wordTranslation.sourceLanguage.id}
                    translationLanguage={wordTranslation.translationLanguage.id}
                    explanationQuotaFieldName={'quotaExplanation2'}
                    explanationCounterFieldName={'counterQuotaExplanation2'}
                    wordMasksController={masksController2}
                    getInfinitives={() => editorRef2.editor.getContent({format: 'text'})}
                    {...props} />
            )} />
        </FormGroup>

        <FormGroup label={'TRANSLATION OF 2nd MNEMO-ENHANCER'} required={true}>
            <Field
                name={'exampleSentenceTranslation2'}
                render={props => <TinyMCE toolbar={''} {...props} />} />
        </FormGroup>

        <div className={'separator'} />

        <FormGroup label={'Info'}>
            <Field
                name={'info'}
                render={props => <TinyMCE toolbar={'bold | audio | preview'} {...props} />} />
        </FormGroup>

        <FormGroup>
            <Field
                name={'editingRequiredAt'}
                render={props => <Checkbox {...props} label={'Editing required'} />} />
        </FormGroup>

        <Observer>
            { () => form?.data.editingRequiredAt ? (
                <FormGroup label={'Comment'}>
                    <Field
                        name={'editingRequiredComment'}
                        render={props => <TextInput {...props} />} />
                </FormGroup>
            ) : null }
        </Observer>

        <FormGroup label={'DERIVABLE from words, already learned?'}>
            <Field
                name={'derivableFromWords'}
                render={props => <TinyMCE toolbar={'bold | audio | preview'} {...props} />} />
        </FormGroup>

        <FormGroup label={'Search here for words, already added before'}>
            <Async
                loadOptions={debounce(async (query) => {
                    const result = await graphql.client.query<SearchAlreadyCreatedCardsQuery, SearchAlreadyCreatedCardsQueryVariables>({
                        query: SearchAlreadyCreatedCardsDocument,
                        variables: {
                            query,
                            sourceLanguage: wordTranslation.sourceLanguage.id,
                            translationLanguage: wordTranslation.translationLanguage.id,
                        }
                    });

                    return result.data.searchAlreadyCreatedCards.map(result => ({
                        label: result.text,
                        value: result.id
                    }));
                }, 300)}
                options={[]} />
        </FormGroup>

        <div className={'col-12'}>
            <FormErrorMessage />
            <Field submit render={props => <SubmitButton {...props}>Done</SubmitButton>} />
        </div>

        <div style={{ height: 500 }} />
    </Form>
};

export const CreateVocabulary = props => (
    <div className={'index-wrapper'}>
        <div className={'index-page'}>
            <CreateVocabularyForm />
        </div>
    </div>
);
